import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ObserverService {

    private channels: { [key: string]: Subject<any>; } = {};

    subscribe(topic: string, observer: (_: any) => void): Subscription {
        if (!this.channels[topic]) {
            this.channels[topic] = new Subject<any>();
        }
        
        return this.channels[topic].subscribe(observer);
    }

    publish(topic: string, data: any): void {

        const matched_channels = [];

        for (var key in this.channels) {
            let key_parts = key.split('|');
            if(key_parts[0] == topic) {
                matched_channels.push(this.channels[key]);
            }
        }

        if(matched_channels.length) {
            for (var i = 0; i < matched_channels.length; i++) {
                let subject = matched_channels[i];
                subject.next(data);
            }
        }
        else {
            return;
        }

    }

    destroy(topic: string): null {
        const subject = this.channels[topic];
        if (!subject) {
            return;
        }
        subject.complete();
        delete this.channels[topic];
    }

}
